import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation DeleteFarm($farmId: String!) {
    archiveFarm(farmId: $farmId) {
      id
    }
  }
`;

export type DeleteFn = (farmId: string) => void;

export type CompletedFn = (farm: Farm) => void;

interface Result {
  archiveFarm: Farm;
}

interface Props {
  onCompleted: CompletedFn;
  children: (
    execute: DeleteFn,
    loading: boolean,
    done: boolean
  ) => React.ReactNode;
}

const DeleteFarmProvider: React.StatelessComponent<Props> = (props: Props) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={(data: Result) =>
        data ? props.onCompleted(data.archiveFarm) : null
      }
    >
      {(mutateFn, result) =>
        props.children(
          (farmId: string) => mutateFn({ variables: { farmId } }),
          result.loading,
          result.data && result.data.archiveFarm && result.data.archiveFarm.id
        )
      }
    </AuthorizedMutation>
  );
};

export default DeleteFarmProvider;



// WEBPACK FOOTER //
// ./src/providers/DeleteFarmProvider.tsx